export default __webpack_public_path__ + "static/media/SQL_Generator.78e1bc1c.png";